// ===================================================
// File: src/components/InfoAlert/InfoAlert.jsx
// ===================================================
import React from "react";
import { createPortal } from "react-dom";
import "./InfoAlert.scss";

const InfoAlert = ({
  isOpen,
  onClose,
  title = "Information",
  message = "This is an information alert.",
  type = "info", // success, danger, warning, info, primary, secondary
  icon = "fas fa-info-circle",
  buttonText = "OK",
  cancelText = "",
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  const getIconByType = (alertType) => {
    const icons = {
      success: "fas fa-check-circle text-success",
      danger: "fas fa-exclamation-circle text-danger",
      warning: "fas fa-exclamation-triangle text-warning",
      info: "fas fa-info-circle text-info",
      primary: "fas fa-info-circle text-primary",
      secondary: "fas fa-info-circle text-secondary",
    };
    return icons[alertType] || icon;
  };

  const getButtonClass = (alertType) => {
    const classes = {
      success: "btn-success",
      danger: "btn-danger",
      warning: "btn-warning",
      info: "btn-info",
      primary: "btn-primary",
      secondary: "btn-secondary",
    };
    return classes[alertType] || "btn-primary";
  };

  const handleDismiss = () => {
    onCancel?.();
    onClose?.();
  };

  const handleConfirm = () => {
    onConfirm?.();
    onClose?.();
  };

  const isConfirmAlert = Boolean(cancelText);

  // Portal to body so table / compact parent font-size does not shrink the dialog.
  return createPortal(
    <div
      className="modal fade show d-block aq-info-alert"
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 10000000 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title d-flex align-items-center">
              <i className={`${getIconByType(type)} me-2`}></i>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={isConfirmAlert ? handleDismiss : onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p className="mb-0 aq-info-alert__message">{message}</p>
          </div>
          <div className="modal-footer border-0">
            {isConfirmAlert ? (
              <>
                <button type="button" className="btn btn-outline-secondary" onClick={handleDismiss}>
                  {cancelText}
                </button>
                <button
                  type="button"
                  className={`btn ${getButtonClass(type)}`}
                  onClick={handleConfirm}
                >
                  <i className="fas fa-check me-1"></i> {buttonText}
                </button>
              </>
            ) : (
              <button
                type="button"
                className={`btn ${getButtonClass(type)}`}
                onClick={onClose}
              >
                <i className="fas fa-check me-1"></i> {buttonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default InfoAlert;
